import { Spinner } from '@talentmesh/ui/components/spinner';

function TabLoadingSpinner() {
    return (
        <div className="flex h-128 items-center justify-center">
            <Spinner className="text-primary size-8" />
        </div>
    );
}

export default TabLoadingSpinner;
